module.exports = __webpack_public_path__ + "img/7_37.119eeab3.png";